import type { MiddlewareParams } from '@haaretz/s-types';

export default function userAgentDispenserMiddleware({ ctx }: MiddlewareParams) {
  const userAgent = ctx.req.headers['user-agent'];

  if (!userAgent) throw new Error('User agent not found');

  return Promise.resolve({ userAgent });
}
